export const flow = {
  formId: "save-flow",
  formField: {
    flowName: {
      name: "flowName",
      label: "flow name",
      type: "text",
      placeholder: "eg. New flow",
      errorMsg: "Flow Name is required.",
    },
    description: {
      name: "description",
      label: "description",
      type: "text",
      placeholder: "eg. This is an information about the flow",
      errorMsg: "Description is required.",
    },
    status: {
      name: "shared_status",
      label: "Active",
      type: "text",
    },
  },
};
